module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "part",
      "role": "doc-part"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/part1.jpg"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "page 8",
      "id": "page_8",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sideh"
  }, [_vm._v("A Note: Why Start with Storytelling?")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt"
  }, [_vm._v("When we use the word "), _c('em', [_vm._v("conversation")]), _vm._v(", we generally think of dialogue with others. We tend not to think about the often-ignored, private thoughts that bounce around in our heads—sometimes called “the committee.” But we really should include them in a discussion about conversations because our inner thoughts create and reflect the stories we believe and live by. Those private thoughts—whether conscious or unconscious— are the stories we believe and the bedrock of our communication.")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxti"
  }, [_vm._v("Stories aren’t inert. They contain truths and falsehoods and persuasive powers that can change minds, relationships, and decisions. I start by exploring our personal stories because you and your stories are the common denominator in every interaction, no matter who you’re speaking with and no matter the context.")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxti"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1"
    }
  }, [_vm._v("Chapters 1")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(", and "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" focus on our personal thoughts. Those chapters introduce tools and practices for investigating our stories. Take a moment to think of something you have had rolling around in your head that distracted you or kept you up at night. Does that thought make you worry or feel stressed? Unexplored, such thoughts influence what and how we think and feel and how we interact. Conversely, becoming conscious of internal stories liberates us from their grip and taps into our inherent wisdom.")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxti"
  }, [_vm._v("A word on "), _c('em', [_vm._v("wisdom")]), _vm._v(". I like the Merriam-Webster Dictionary definition.")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt1"
  }, [_vm._v("1a: ability to discern inner qualities and relationships:: INSIGHT")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt1a"
  }, [_vm._v("b: good sense: JUDGMENT")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt1a"
  }, [_vm._v("c: generally accepted belief // challenges what has become accepted wisdom among many historians—Robert Darnton")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt1a"
  }, [_vm._v("d: accumulated philosophical or scientific learning:"), _c('br'), _vm._v("KNOWLEDGE")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt1"
  }, [_vm._v("2: a wise attitude, belief, or course of action:")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt1"
  }, [_vm._v("3: the teachings of the ancient wise men:"), _c('span', {
    attrs: {
      "aria-label": "page 9",
      "id": "page_9",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sidetxtt"
  }, [_vm._v("Wisdom relies on our ability to reason productively about problems or breakdowns. Wise attributes include our intuition and insight, our ability to engage others with curiosity, decision-making based on conceptual and factual information, and humility to know the limits of our knowledge. By starting with our storytelling selves, we can accumulate a wiser perspective for reconsidering all conversations.")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" explains how our brains, egos, awareness, and autopilot patterns serve or thwart our conversations.")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" explores the crucial elements of our stories—facts, emotions, and opinions.")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" introduces us to the consequential gap between our public words and our private thoughts—increasing our awareness of how it impacts our conversations.")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" introduces four archetypal questions—desires, concerns, power dynamics, and standards of judgment—as a guide for investigating stories.")]), _vm._v(" "), _c('p', {
    staticClass: "sidetxtt"
  }, [_vm._v("Let’s begin breaking down our stories. You might laugh or cry as you engage with the committee, but in the end it will be worth the effort because you will be a better conversationalist."), _c('span', {
    attrs: {
      "aria-label": "page 10",
      "id": "page_10",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 11",
      "id": "page_11",
      "role": "doc-pagebreak"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab456b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 78
// module chunks = 0